<section>
  <gus-dialog-header *ngIf="!customHeader(); else projectedDialogHeader" (closeDialog)="close()"></gus-dialog-header>

  <gus-dialog-body *ngIf="!customBody(); else projectedDialogBody"></gus-dialog-body>
</section>

<gus-dialog-footer
  *ngIf="!customFooter(); else projectedDialogFooter"
  [isLoading]="isLoading"
  (primaryButtonClicked)="handlePrimaryButtonClick()"
  (secondaryButtonClicked)="handleSecondaryButtonClick()"
></gus-dialog-footer>

<ng-template #projectedDialogHeader>
  <ng-content select="gus-dialog-header"></ng-content>
</ng-template>

<ng-template #projectedDialogBody>
  <ng-content select="gus-dialog-body"></ng-content>
</ng-template>

<ng-template #projectedDialogFooter>
  <ng-content select="gus-dialog-footer"></ng-content>
</ng-template>
